import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { IClient } from "src/services/ClientService";
import { VBox } from "@ui/box/Box";
import { Typo } from "@ui/text/Typo";
import { Spinner } from "@ui/spinner/Spinner";
import { Page } from "@ui/page/Page";
import { Rows } from "@ui/table/Rows";
import { CountryClip } from "src/view/conponents/icons/CountryClip";
import Spacer from "@ui/spacer/Spacer";
import { useRouter } from "src/services/Router";

const getRequest = (acquirerId?: number, channelId?: number, terminalId?: number, status?: number) => {
	return { acquirerId: acquirerId, channelId: channelId, terminalId: terminalId, status: status };
};

export const ClientRegisterSelector = () => {
	useLocale();
	const [req, _reloadClients, _, _busy] = GD.REQ_CLIENTS.useRequest(undefined, getRequest(undefined, undefined, undefined));
	const router = useRouter();
	//const [selectedClient, setSelectedClient] = useState<IClient | null>(null);
	const [avaliableClients, setAvaliableClients] = useState<IClient[] | null>(null);

	useEffect(() => {
		if (req && req.data) {
			if (req.data.length === 0) {
				registerNewClient();
			} else {
				const clientsForRegistration = req.data.filter((client: any) => {
					return client.status === "created" || client.status === "in_progress" || client.status === "rejected";
				});
				if (clientsForRegistration.length === 1) {
					if (
						clientsForRegistration[0].status === "created" ||
						clientsForRegistration[0].status === "in_progress" ||
						clientsForRegistration[0].status === "rejected"
					) {
						navigateToRegister(clientsForRegistration[0]);
					} else {
						//!TODO: handle other statuses
					}
				} else {
					setAvaliableClients(clientsForRegistration);
				}
			}
		} else {
			if (req && req.error) {
				if (req.error.code === 13) {
					registerNewClient();
				}
			}
		}
		// Any side effects or logic can be added here
	}, [req]);

	const registerNewClient = async () => {
		router.navigate("registerClient", { rid: "0" });
	};

	const navigateToRegister = (client: IClient) => {
		router.navigate("registerClient", { rid: client.id + "" });
	};

	if (!avaliableClients) {
		return (
			<VBox gap="30px" sx={{ alignItems: "center", justifyContent: "center", height: "100%" }}>
				<Spinner />
				<Typo variant="headMedium">{msg("loading")}</Typo>
			</VBox>
		);
	}

	// if (selectedClient) {
	// 	return <RegisterPage clientId={selectedClient.id} clientStatus={selectedClient.status} />;
	// }
	if (avaliableClients) {
		return (
			<Page sx={{ padding: "0px", overflow: "auto" }}>
				<VBox gap="20px" sx={{ padding: "20px", maxWidth: "900px", minWidth: "800px", alignSelf: "center" }}>
					<Spacer size="10px" />
					<Typo sx={{ alignSelf: "center" }} variant="head">{msg("selectAClientToContinueRegistration")}</Typo>

					<Rows
						searchable={req?.data && req.data.length > 15}
						controlsPadding="20px"
						scrollable={true}
						// error={req?.error}
						data={req?.data ?? []}
						itemType="client"
						gridTemplateColumns="max-content max-content 1fr   auto"
						order={["__itemType", "country", "name", "status"]}
						onClick={row => navigateToRegister(row)}
						cellFactory={(row, cell, _index, _key, name, sx, _expanded, _rowID) => {
							if (name === "country") {
								sx && (sx.paddingRight = "1px");
								return {
									content: <CountryClip code={row.country} />,
									sx: { ...sx, padding: "10px 0px 10px 10px" },
								};
							}

							return { content: cell };
						}}
					/>
				</VBox>
			</Page>
		);
	}

	return null;
};
